import request from '@/utils/request'

//其他出库



//详情
export function getqtckDetailList(data) {
    return request({
        method: 'get',
        url: "/yzdservice/api/enterprise/qtck/detail/" + data
    })
}
//新增时检查库存量
export function qtckaddjckcl(data) {
    return request({
        method: 'post',
        url: "/yzdservice/api/enterprise/qtck/check",
        data: data
    })
}
//其他出库新增（暂时保存）
export function addQtckTemp(data) {
    return request({
        method: 'post',
        url: "/yzdservice/api/enterprise/qtck/addTemp",
        data: data
    })
}
//其他出库新增（出库保存）
export function addQtck(data) {
    return request({
        method: 'post',
        url: "/yzdservice/api/enterprise/qtck/add",
        data: data
    })
}
//删除
export function deleteQtck(data) {
    return request({
        method: 'delete',
        url: "/yzdservice/api/enterprise/qtck/delete/" + data
    })
}
//其他出库编辑（暂时保存）
export function editQtckTemp(data) {
    return request({
        method: 'post',
        url: "/yzdservice/api/enterprise/qtck/editTemp",
        data: data
    })
}
//其他出库编辑（出库保存）
export function editQtck(data) {
    return request({
        method: 'post',
        url: "/yzdservice/api/enterprise/qtck/edit",
        data: data
    })
}
//导出
export function exportqtckList(data) {
    return request({
        method: 'post',
        url:  "/yzdservice/api/enterprise/qtck/excelwriter",
        responseType: 'blob',
        data: data
    })
}
//变更时检查库存量
export function qtckbgjckcl(data) {
    return request({
        method: 'post',
        url: "/yzdservice/api/enterprise/qtck/change",
        data: data
    })
}
//变更
export function qtckbg(data) {
    return request({
        method: 'post',
        url: "/yzdservice/api/enterprise/qtck/saveChangeApply",
        data: data
    })
}
//列表
export function qtckliebiaoList(data) {
    return request({
        method: 'post',
        url: "/yzdservice/api/enterprise/qtck/list",
        data: data
    })
}
//获取单位化学品
export function getHxpCascader() {
    return request({
        method: 'get',
        url: "/yzdservice/api/enterprise/credentials/common/getHxpCascader"
    })
}
//获取经办人下拉
export function getLyrList() {
    return request({
        method: 'get',
        url: "/yzdservice/enterprise/dwCk/syck/getLyrList"
    })
}
